/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import classNames from "classnames";
import { Box, Pagination, AuthorizedCACFormDrawer } from "@ui-kit/components/index.es";
import Button from "pages/_components/Button";
import Card from "pages/_components/Card/Card";
import { compose } from "redux";
import Yup from "yup";
import { Field, Form, withFormik } from "formik";
import Checkbox from "pages/_components/Checkbox";
import CardContainer from "pages/_components/Card/CardContainer";
import Container from "pages/_components/Container";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import Head from "pages/_components/Head";
import Hint from "pages/_components/hints/Hint";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import SelectedAccountsAmount from "pages/charges/_components/SelectedAccountsAmount";
import Credential from "pages/_components/fields/credentials/Credential";
import { arrayOf, bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import { selectors as accountsSelectors } from "reducers/accounts";
import { actions, selectors } from "reducers/checks";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as notificationActions } from "reducers/notification";
import { accountDescription, echeqConceptLabel, echeqShape, findEmisor } from "util/checks";
import * as configUtils from "util/config";
import * as i18n from "util/i18n";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";
import isTokenActive from "util/token";

const FORM_ID = "echeqs";

class ConfirmEcheqAction extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        echeqAction: shape({
            action: string.isRequired,
            echeqList: arrayOf(echeqShape),
            specialAttribute: string.isRequired,
            confirmGoBackPath: string,
        }).isRequired,
        accounts: arrayOf(shape({})).isRequired,
        userId: string.isRequired,
        environmentCuit: string.isRequired,
        isDesktop: bool.isRequired,
        values: shape({}).isRequired,
        fetching: bool.isRequired,
        setValues: func.isRequired,
        authorizedPersons: arrayOf(shape({})).isRequired,
        history: shape({
            location: shape({
                pathname: string,
            }),
        }).isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    state = {
        submitting: false,
        currentPage: 1,
        buttonBoxHeight: 0,
        authorizedCACFormDrawerOpen: false,
    };

    componentDidMount = () => {
        const { echeqAction, isDesktop } = this.props;

        if (!echeqAction.action) {
            this.handleBack();
        }
        const buttonBox = document.getElementById("confirmation-without-otp-box-button-mobile");
        if (buttonBox && !isDesktop) {
            this.setState({ buttonBoxHeight: buttonBox.offsetHeight });
        }
        this.applyV3ShellLayout();
    };

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, echeqAction } = this.props;
        if (
            prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
            prevProps.isDesktop !== isDesktop ||
            prevProps.echeqAction !== echeqAction
        ) {
            this.applyV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell, history } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch, { nextPathname: history?.location?.pathname || "" });
        }
    }

    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber });
    };

    getCurrentPageEcheqs = () => {
        const { echeqAction } = this.props;
        const { currentPage } = this.state;
        const itemsPerPage = configUtils.getInteger("frontend.MultipleSelection.charges.rowsPerPage", 5);

        if (!echeqAction?.echeqList) {
            return [];
        }

        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return echeqAction.echeqList.slice(startIndex, endIndex);
    };

    getTotalPages = () => {
        const { echeqAction } = this.props;
        const itemsPerPage = configUtils.getInteger("frontend.MultipleSelection.charges.rowsPerPage", 5);

        if (!echeqAction?.echeqList) {
            return 0;
        }

        return Math.ceil(echeqAction.echeqList.length / itemsPerPage);
    };

    getShellHeaderTitle = () => {
        const { echeqAction } = this.props;
        if (!echeqAction?.action) {
            return "";
        }
        const titleKey =
            echeqAction?.echeqList?.length > 1
                ? `${FORM_ID}.${echeqAction.action.toLowerCase()}.title.multi`
                : `${FORM_ID}.${echeqAction.action.toLowerCase()}.title`;
        return i18n.get(titleKey);
    };

    applyV3ShellLayout = () => {
        const { embeddedInV3Shell, isDesktop, dispatch, echeqAction } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["echeqs"],
            headerTitle: this.getShellHeaderTitle(),
            goBackPath: echeqAction.confirmGoBackPath || "/echeqs",
        });
    };

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    };

    closeEcheqAction = () => {
        const { dispatch } = this.props;

        dispatch(actions.cleanEcheqAction());
        this.handleBack();
    };

    createAccountDescription = () => {
        const { echeqAction, accounts } = this.props;
        const { specialAttribute } = echeqAction;
        const account = accounts.find((a) => a.idProduct === specialAttribute);

        const { productAlias, number, currency, productType } = account;

        return accountDescription(productAlias, number, currency, productType);
    };

    executeEcheqAction = () => {
        const { dispatch, echeqAction, userId, accounts } = this.props;
        let attribute = echeqAction.specialAttribute;
        let attribute2 = "";
        let attribute3 = "";
        if (echeqAction.action === "CUSTODY" || echeqAction.action === "DEPOSIT") {
            const accountSelected = accounts.find((account) => account.idProduct === echeqAction.specialAttribute);
            attribute = accountSelected.cbu;
            attribute2 = accountSelected.productType === "CA" ? "05" : "03";
            if (accountSelected.number.length < 11) {
                const spacesToFill = 11 - accountSelected.number.length;
                for (let i = 0; i < spacesToFill; i++) {
                    attribute3 += "0";
                }
                attribute3 += accountSelected.number;
            }
        }
        this.setState({ submitting: true });
        const asyncEcheqActionsEnabled = configUtils.getBoolean(
            "Services.Admitir.Repudiar.Depositar.Custodiar.Async",
            false,
        );

        if (
            asyncEcheqActionsEnabled &&
            echeqAction.echeqList?.length > 1 &&
            (echeqAction.action === "ADMIT" ||
                echeqAction.action === "REPUDIATE" ||
                echeqAction.action === "CUSTODY" ||
                echeqAction.action === "DEPOSIT")
        ) {
            dispatch(
                actions.executeActionEcheqAsync(
                    {
                        ...echeqAction,
                        specialAttribute: attribute,
                        specialAttribute2: attribute2,
                        specialAttribute3: attribute3,
                    },
                    userId,
                ),
            );
        } else {
            dispatch(
                actions.executeActionEcheq(
                    {
                        ...echeqAction,
                        specialAttribute: attribute,
                        specialAttribute2: attribute2,
                        specialAttribute3: attribute3,
                    },
                    userId,
                ),
            );
        }
    };

    totalEcheqs = () => {
        const { echeqAction } = this.props;
        return (
            echeqAction?.echeqList?.length > 1 && (
                <SelectedAccountsAmount
                    currency={echeqAction.echeqList[0]?.moneda}
                    list={echeqAction?.echeqList}
                    summaryView
                />
            )
        );
    };

    renderHeader = () => {
        const { echeqAction, isDesktop, embeddedInV3Shell } = this.props;
        const hideMobileLegacyHeader = embeddedInV3Shell && isUxDashboardImprovementsEnabled() && !isDesktop;
        const title =
            echeqAction?.echeqList?.length > 1
                ? `${FORM_ID}.${echeqAction?.action?.toLowerCase()}.title.multi`
                : `${FORM_ID}.${echeqAction?.action?.toLowerCase()}.title`;
        const subTitle =
            echeqAction?.action === "ADMIT"
                ? `${FORM_ID}.${echeqAction?.action?.toLowerCase()}.subtitle`
                : "echeqs.action.subtitle";

        if (isDesktop) {
            return (
                <div className="admin-detail-head px-0 echeq-header">
                    <Head onBack={this.handleBack} onClose={this.closeEcheqAction} />
                    <Container className="flex-grow align-items-center mb-2" gridClassName="form-content">
                        <Col xs={12} lg={12} className="px-0 justify-content-start" style={{ alignItems: "center" }}>
                            <div className="px-0">
                                <Head title={title} centerContentClassName="p-0" />
                                <I18n
                                    id={subTitle}
                                    component="h4"
                                    componentProps={{
                                        className: `mb-0`,
                                    }}
                                />
                            </div>
                        </Col>
                        <Col lg={12} className="echeq__totals justify-content-end d-flex">
                            {this.totalEcheqs()}
                        </Col>
                    </Container>
                </div>
            );
        }

        if (hideMobileLegacyHeader) {
            return null;
        }

        return (
            <Head
                emptyRightOption
                headerClassName="blue-main-header-mobile blue-main-title-mobile"
                onBack={this.handleBack}
                title={title}
            />
        );
    };

    handleAuthorizedPersons = ({ authorizedPersons }) => {
        const { dispatch } = this.props;
        dispatch(actions.setAuthorizedPersons(authorizedPersons));
        this.setState({ authorizedCACFormDrawerOpen: false });
    };

    render() {
        const {
            dispatch,
            echeqAction,
            environmentCuit,
            isDesktop,
            embeddedInV3Shell,
            values,
            fetching,
            authorizedPersons,
            setValues,
        } = this.props;
        const { submitting, buttonBoxHeight, authorizedCACFormDrawerOpen } = this.state;
        const firstEcheq = echeqAction?.echeqList?.[0];
        const isCaducado = firstEcheq?.estado?.trim()?.toUpperCase() === "CADUCADO";
        const enableCAC =
            (isCaducado && configUtils.getBoolean("frontend.echeq.expired.certificate.cac.functionalities")) ||
            (!isCaducado && configUtils.getBoolean("frontend.echeq.rejected.certificate.cac.functionalities"));
        const cacHint = configUtils.get("echeq.rejected.certificate.text.disclaimer");
        const subTitle =
            echeqAction?.action === "ADMIT"
                ? `${FORM_ID}.${echeqAction?.action?.toLowerCase()}.subtitle`
                : "echeqs.action.subtitle";

        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="echeqs" />}
                {this.renderHeader()}
                <MainContainer
                    viewPageClassName="echeq-confirmation__view-page"
                    viewContentClassName="overflow-visible">
                    {!isDesktop && (
                        <>
                            <Col xs={12} className="echeq__totals justify-content-center d-flex">
                                <I18n
                                    id={subTitle}
                                    component="h3"
                                    componentProps={{ className: "my-0 px-5 text-align-center" }}
                                />
                            </Col>
                            <Col xs={12} className="echeq__totals justify-content-end d-flex">
                                {this.totalEcheqs()}
                            </Col>
                        </>
                    )}
                    <div>
                        {(() => {
                            const asyncEcheqActionsEnabled = configUtils.getBoolean(
                                "Services.Admitir.Repudiar.Depositar.Custodiar.Async",
                                false,
                            );

                            const shouldUsePagination = isDesktop && asyncEcheqActionsEnabled;
                            const echeqsToRender = shouldUsePagination
                                ? this.getCurrentPageEcheqs()
                                : echeqAction?.echeqList;

                            return echeqsToRender?.map((echeq) => {
                                const emisor = findEmisor(echeq, environmentCuit);
                                return (
                                    <CardContainer className="confirmation__cards-container mt-0">
                                        <Card
                                            className={`confirmation__cards ${isDesktop && "confirm__icon-gray"}`}
                                            icon={isDesktop && "images/writing-pending.svg"}
                                            iconClass="card__pending-transaction-icon"
                                            title={
                                                isDesktop ? (
                                                    <div className="d-flex align-items-center">
                                                        <div
                                                            className={`confirmation-cards__title ${(echeq.cheque_id ||
                                                                echeqAction.action === "REPUDIATE" ||
                                                                echeqAction.action === "REPUDIATE-CESION" ||
                                                                echeqAction.action === "DEPOSIT" ||
                                                                echeqAction.action === "CUSTODY") &&
                                                                "confirmation-cards-separator"}`}>
                                                            <div className="confirmation-cards__title-data">
                                                                <span>{i18n.get(`${FORM_ID}.fecha_pago`)}</span>
                                                            </div>
                                                            <div className="confirmation-cards__title-info">
                                                                <FormattedDate
                                                                    showTime={false}
                                                                    date={echeq.fecha_pago}
                                                                />
                                                            </div>
                                                        </div>
                                                        {(echeqAction.action === "REPUDIATE" ||
                                                            echeqAction.action === "REPUDIATE-CESION") && (
                                                            <div className="confirmation-cards__title confirmation-cards-separator">
                                                                <div className="confirmation-cards__title-data no-wrap">
                                                                    <span>
                                                                        {i18n.get(`${FORM_ID}.repudiate_motive`)}
                                                                    </span>
                                                                </div>
                                                                <div className="confirmation-cards__title-info withEllipsis">
                                                                    <div className="confirmation-cards__with-ellipsis short">
                                                                        <span>{echeqAction.specialAttribute}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {echeqAction.action === "DEPOSIT" && (
                                                            <div className="confirmation-cards__title confirmation-cards-separator">
                                                                <div className="confirmation-cards__title-data no-wrap">
                                                                    <span>
                                                                        {i18n.get(`${FORM_ID}.deposit.account`)}
                                                                    </span>
                                                                </div>
                                                                <div className="confirmation-cards__title-info withEllipsis">
                                                                    <div className="confirmation-cards__with-ellipsis short">
                                                                        <span>{this.createAccountDescription()}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {echeqAction.action === "CUSTODY" && (
                                                            <div className="confirmation-cards__title confirmation-cards-separator">
                                                                <div className="confirmation-cards__title-data no-wrap">
                                                                    <span>
                                                                        {i18n.get(`${FORM_ID}.custody.account`)}
                                                                    </span>
                                                                </div>
                                                                <div className="confirmation-cards__title-info withEllipsis">
                                                                    <div className="confirmation-cards__with-ellipsis short">
                                                                        <span>{this.createAccountDescription()}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {echeq.cheque_id && (
                                                            <div className="confirmation-cards__title">
                                                                <div className="confirmation-cards__title-data no-wrap">
                                                                    <span>{i18n.get(`${FORM_ID}.cheque_id`)}</span>
                                                                </div>
                                                                <div className="confirmation-cards__title-info">
                                                                    <span>{echeq.cheque_id}</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className="confirmation-cards__title">
                                                        <div className="confirmation-cards__title-data">
                                                            <span>{i18n.get(`${FORM_ID}.cheque_numero`)}</span>
                                                        </div>
                                                        <div className="confirmation-cards__title-info no-wrap">
                                                            <span>{echeq.cheque_numero}</span>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            content={
                                                isDesktop ? (
                                                    <div className="d-flex align-items-center">
                                                        <div className="confirmation-cards__content pb-1">
                                                            <div className="confirmation-cards__content-data">
                                                                <span>{i18n.get(`${FORM_ID}.cheque_numero`)}</span>
                                                            </div>
                                                            <div className="confirmation-cards__content-info">
                                                                <span>{echeq.cheque_numero}</span>
                                                            </div>
                                                        </div>
                                                        <div className="confirmation-cards__content info-type-a">
                                                            <div className="confirmation-cards__content-data">
                                                                <span>{i18n.get(`${FORM_ID}.emitted.from`)}</span>
                                                            </div>
                                                            <div className="confirmation-cards__content-info">
                                                                <span>
                                                                    {emisor.emisorRazonSocial.replaceAll("#", "Ñ")}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="confirmation-cards__content info-type-b">
                                                            <div className="confirmation-cards__content-info">
                                                                <span>{emisor.emisorDocumento}</span>
                                                            </div>
                                                        </div>
                                                        <div className="confirmation-cards__content info-type-c">
                                                            <div className="confirmation-cards__content-data">
                                                                <span>{i18n.get(`${FORM_ID}.cheque_motivo_pago`)}</span>
                                                            </div>
                                                            <div className="confirmation-cards__content-info withEllipsis">
                                                                <div className="confirmation-cards__with-ellipsis short">
                                                                    <span>{echeq.cheque_motivo_pago}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <div className="confirmation-cards__content">
                                                            <div className="confirmation-cards__content-data">
                                                                <span>{i18n.get(`${FORM_ID}.fecha_pago`)}</span>
                                                            </div>
                                                            <div className="confirmation-cards__content-info">
                                                                <FormattedDate
                                                                    showTime={false}
                                                                    date={echeq.fecha_pago}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="confirmation-cards__content">
                                                            <div className="confirmation-cards__content-data">
                                                                <span>{i18n.get(`${FORM_ID}.cheque_id`)}</span>
                                                            </div>
                                                            <div className="confirmation-cards__content-info">
                                                                <span>{echeq.cheque_id}</span>
                                                            </div>
                                                        </div>
                                                        {(echeqAction.action === "REPUDIATE" ||
                                                            echeqAction.action === "REPUDIATE-CESION") && (
                                                            <div className="confirmation-cards__content">
                                                                <div className="confirmation-cards__content-data no-wrap">
                                                                    <span>
                                                                        {i18n.get(`${FORM_ID}.repudiate_motive`)}
                                                                    </span>
                                                                </div>
                                                                <div className="confirmation-cards__content-info withEllipsis">
                                                                    <div className="confirmation-cards__with-ellipsis short">
                                                                        <span>{echeqAction.specialAttribute}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {echeqAction.action === "DEPOSIT" && (
                                                            <div className="confirmation-cards__content">
                                                                <div className="confirmation-cards__content-data no-wrap">
                                                                    <span>
                                                                        {i18n.get(`${FORM_ID}.deposit.account`)}
                                                                    </span>
                                                                </div>
                                                                <div className="confirmation-cards__content-info withEllipsis">
                                                                    <div className="confirmation-cards__with-ellipsis short">
                                                                        <span>{this.createAccountDescription()}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {echeqAction.action === "CUSTODY" && (
                                                            <div className="confirmation-cards__content">
                                                                <div className="confirmation-cards__content-data no-wrap">
                                                                    <span>
                                                                        {i18n.get(`${FORM_ID}.custody.account`)}
                                                                    </span>
                                                                </div>
                                                                <div className="confirmation-cards__content-info withEllipsis">
                                                                    <div className="confirmation-cards__with-ellipsis">
                                                                        <span>{this.createAccountDescription()}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="confirmation-cards__content">
                                                            <div className="confirmation-cards__content-data">
                                                                <span>{i18n.get(`${FORM_ID}.emitted.from`)}</span>
                                                            </div>
                                                            <div className="confirmation-cards__content-info">
                                                                <span>
                                                                    {emisor.emisorRazonSocial.replaceAll("#", "Ñ")}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="confirmation-cards__content">
                                                            <div className="confirmation-cards__content-data">
                                                                <span>
                                                                    {i18n.get(`${FORM_ID}.beneficiario_documento`)}
                                                                </span>
                                                            </div>
                                                            <div className="confirmation-cards__content-info">
                                                                <span>{emisor.emisorDocumento}</span>
                                                            </div>
                                                        </div>
                                                        <div className="confirmation-cards__content">
                                                            <div className="confirmation-cards__content-data">
                                                                <span>{i18n.get(`${FORM_ID}.cheque_motivo_pago`)}</span>
                                                            </div>
                                                            <div className="confirmation-cards__content-info withEllipsis">
                                                                <div className="confirmation-cards__with-ellipsis">
                                                                    <span>{echeq.cheque_motivo_pago}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="confirmation-cards__content">
                                                            <div className="confirmation-cards__content-data">
                                                                <span>{i18n.get(`${FORM_ID}.cheque_caracter`)}</span>
                                                            </div>
                                                            <div className="confirmation-cards__content-info">
                                                                <span className="text-uppercase">
                                                                    {echeq.cheque_caracter}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="confirmation-cards__content">
                                                            <div className="confirmation-cards__content-data">
                                                                <span>{i18n.get(`${FORM_ID}.cheque_modo`)}</span>
                                                            </div>
                                                            <div className="confirmation-cards__content-info">
                                                                <span>
                                                                    {i18n.get(`echeqs.${echeq.cheque_modo}.modo`)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="confirmation-cards__content">
                                                            <div className="confirmation-cards__content-data">
                                                                <span>{i18n.get(`${FORM_ID}.cheque_concepto`)}</span>
                                                            </div>
                                                            <div className="confirmation-cards__content-info withEllipsis">
                                                                <div className="confirmation-cards__with-ellipsis">
                                                                    <span>
                                                                        {echeqConceptLabel(echeq.cheque_concepto, "")}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="confirmation-cards__content">
                                                            <div className="confirmation-cards__content-data">
                                                                <span>{i18n.get(`${FORM_ID}.cheque_tipo`)}</span>
                                                            </div>
                                                            <div className="confirmation-cards__content-info">
                                                                <span>{echeq.cheque_tipo}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            bottom={
                                                isDesktop && (
                                                    <div className="d-flex align-items-center">
                                                        {echeq.cheque_caracter && (
                                                            <div
                                                                className={`confirmation-cards__bottom ${(echeq.cheque_modo ||
                                                                    echeq.cheque_concepto ||
                                                                    echeq.cheque_tipo) &&
                                                                    "confirmation-cards-separator"}`}>
                                                                <div className="confirmation-cards__bottom-data">
                                                                    <span>
                                                                        {i18n.get(`${FORM_ID}.cheque_caracter`)}
                                                                    </span>
                                                                </div>
                                                                <div className="confirmation-cards__bottom-info text-uppercase">
                                                                    <span>{echeq.cheque_caracter}</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {echeq.cheque_modo !== null && echeq.cheque_modo !== undefined && (
                                                            <div
                                                                className={`confirmation-cards__bottom ${(echeq.cheque_concepto ||
                                                                    echeq.cheque_tipo) &&
                                                                    "confirmation-cards-separator"}`}>
                                                                <div className="confirmation-cards__bottom-data">
                                                                    <span>{i18n.get(`${FORM_ID}.cheque_modo`)}</span>
                                                                </div>
                                                                <div className="confirmation-cards__bottom-info">
                                                                    <span>
                                                                        {i18n.get(`echeqs.${echeq.cheque_modo}.modo`)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {echeq.cheque_concepto && (
                                                            <div
                                                                className={`confirmation-cards__bottom ${echeq.cheque_tipo &&
                                                                    "confirmation-cards-separator"}`}>
                                                                <div className="confirmation-cards__bottom-data">
                                                                    <span>
                                                                        {i18n.get(`${FORM_ID}.cheque_concepto`)}
                                                                    </span>
                                                                </div>
                                                                <div className="confirmation-cards__bottom-info">
                                                                    <span>
                                                                        {echeqConceptLabel(echeq.cheque_concepto, "")}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {echeq.cheque_tipo && (
                                                            <div className="confirmation-cards__bottom">
                                                                <div className="confirmation-cards__bottom-data">
                                                                    <span>{i18n.get(`${FORM_ID}.cheque_tipo`)}</span>
                                                                </div>
                                                                <div className="confirmation-cards__bottom-info">
                                                                    <span>{echeq.cheque_tipo}</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            }
                                            rightContent={
                                                <div className="confirmation-cards__right">
                                                    <div className="confirmation-cards__right-data">
                                                        <FormattedAmount
                                                            currency={i18n.get(
                                                                "currency.label.".concat(
                                                                    echeq.moneda || echeq.emisor_moneda,
                                                                ),
                                                            )}
                                                            quantity={echeq.monto}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        />
                                    </CardContainer>
                                );
                            });
                        })()}

                        {(() => {
                            const asyncEcheqActionsEnabled = configUtils.getBoolean(
                                "Services.Admitir.Repudiar.Depositar.Custodiar.Async",
                                false,
                            );
                            const shouldUsePagination = isDesktop && asyncEcheqActionsEnabled;
                            const totalPages = this.getTotalPages();
                            const { currentPage } = this.state;

                            return shouldUsePagination && totalPages > 1 ? (
                                <div className="d-flex justify-content-end mb-3">
                                    <Pagination
                                        totalPages={totalPages}
                                        pageNumber={currentPage}
                                        action={this.handlePageChange}
                                    />
                                </div>
                            ) : null;
                        })()}

                        {echeqAction?.action === "REQUEST-CERTIFICATE" && enableCAC ? (
                            <>
                                <Form>
                                    <Container
                                        className={classNames(
                                            "flex-grow align-items-center container-white with-margin with-padding p-3 w-auto",
                                            {
                                                "mt-0": isDesktop,
                                                "mt-3 mx-3": !isDesktop,
                                            },
                                        )}
                                        gridClassName="form-content px-0"
                                        rowClassName="f-dir-col align-items-center">
                                        <Box css={{ paddingBottom: 16 }}>
                                            <Container className="align-items-center flex-grow">
                                                <Col className="col-12 col-xl-6" lg={9} md={9} sm={12}>
                                                    <Hint
                                                        defaultValue={cacHint}
                                                        styleText={{ maxWidth: "100%" }}
                                                        styleImage={{ alignSelf: "center", marginTop: "0.7rem" }}
                                                        classNameHintP="hint-font-size-small"
                                                        alwaysShowMessage
                                                    />
                                                    <Field
                                                        className="d-flex justify-content-center"
                                                        component={Checkbox}
                                                        idForm={FORM_ID}
                                                        name="authorize"
                                                        isDesktop={isDesktop}
                                                        onChange={(value) => {
                                                            this.setState({ authorizedCACFormDrawerOpen: value });
                                                            if (!value) {
                                                                dispatch(actions.setAuthorizedPersons([]));
                                                            }
                                                        }}
                                                    />
                                                </Col>
                                            </Container>
                                        </Box>
                                    </Container>
                                    {values?.authorize && (
                                        <Container
                                            className={classNames(
                                                "flex-grow align-items-center container-white with-margin with-padding p-3 w-auto",
                                                {
                                                    "mt-0": isDesktop,
                                                    "mt-3 mx-3": !isDesktop,
                                                },
                                            )}
                                            gridClassName="form-content px-0"
                                            rowClassName="f-dir-col align-items-center">
                                            <Col className="col-12 col-xl-5" lg={9} md={9} sm={12}>
                                                <Box css={{ paddingBottom: 16 }}>
                                                    <div className="admin-content-center">
                                                        {!isTokenActive(!isDesktop) ? (
                                                            <div className="admin-content-center">
                                                                <I18n id="transfer.summary.confirm.label" />
                                                            </div>
                                                        ) : (
                                                            <div className="admin-content-center pb-3">
                                                                <I18n
                                                                    id="confirmation.withoutotp.text"
                                                                    component="p"
                                                                    componentProps={{
                                                                        className: "confirmation__text-without-otp",
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                        <div className="admin-content-center echeq__solicitude-pass">
                                                            <Field
                                                                placeholderText={i18n.get(
                                                                    `confirmation.otp.placeholder`,
                                                                )}
                                                                name="otp"
                                                                type="otp"
                                                                idForm={FORM_ID}
                                                                component={Credential}
                                                            />
                                                        </div>
                                                    </div>
                                                </Box>
                                            </Col>
                                        </Container>
                                    )}
                                    <>
                                        <AuthorizedCACFormDrawer
                                            key={authorizedCACFormDrawerOpen}
                                            isVisible={authorizedCACFormDrawerOpen}
                                            getTexts={(key) =>
                                                i18n.get(
                                                    `${FORM_ID}.${echeqAction?.action?.toLowerCase()}.modal.${key}`,
                                                )
                                            }
                                            onSubmit={this.handleAuthorizedPersons}
                                            setOpen={(open) => {
                                                if (authorizedPersons?.length < 1) {
                                                    setValues({ ...values, authorize: false });
                                                }
                                                this.setState({ authorizedCACFormDrawerOpen: open });
                                            }}
                                            validations={undefined}
                                        />
                                    </>
                                    {values?.authorize && (
                                        <Container
                                            className="flex-grow align-items-center with-margin with-padding p-3 mt-0"
                                            gridClassName="form-content px-0"
                                            rowClassName="f-dir-col align-items-center">
                                            <Col xs={12} md={3} lg={3} className="px-1">
                                                <Button
                                                    type="submit"
                                                    bsStyle="primary"
                                                    label="global.confirm"
                                                    loading={fetching}
                                                    image="images/arrowRight.svg"
                                                    imageStyle="mr-2"
                                                    className="text-capitalize"
                                                />
                                            </Col>
                                        </Container>
                                    )}
                                </Form>
                                {!values?.authorize && (
                                    <Container
                                        className="flex-grow align-items-center with-margin with-padding p-3 mt-0"
                                        gridClassName="form-content px-0"
                                        rowClassName="f-dir-col align-items-center">
                                        <Col xs={12} md={3} lg={3} className="px-1">
                                            <Button
                                                type="submit"
                                                bsStyle="primary"
                                                label="global.confirm"
                                                loading={submitting}
                                                image="images/arrowRight.svg"
                                                imageStyle="mr-2"
                                                className="text-capitalize"
                                                onClick={this.executeEcheqAction}
                                            />
                                        </Col>
                                    </Container>
                                )}
                            </>
                        ) : (
                            <Container
                                className="flex-grow align-items-center container-white with-margin with-padding p-3 mt-0"
                                gridClassName="form-content px-0"
                                rowClassName="f-dir-col align-items-center">
                                <Box css={{ paddingBottom: buttonBoxHeight + 16 }}>
                                    <Container className="align-items-center flex-grow">
                                        <Col className="col-12 col-xl-9" lg={9} md={9} sm={12}>
                                            {echeqAction.action === "RESCUE" && (
                                                <Hint
                                                    idMessage={`${FORM_ID}.rescue.hint`}
                                                    styleText={{ maxWidth: "100%" }}
                                                    styleImage={{ alignSelf: "center", marginTop: "0.7rem" }}
                                                    classNameHintP="hint-font-size-small"
                                                    alwaysShowMessage
                                                />
                                            )}
                                            {echeqAction.action === "CUSTODY" && (
                                                <Hint
                                                    idMessage={`${FORM_ID}.custody.hint`}
                                                    styleText={{ maxWidth: "100%" }}
                                                    styleImage={{ alignSelf: "center", marginTop: "0.7rem" }}
                                                    classNameHintP="hint-font-size-small"
                                                    alwaysShowMessage
                                                />
                                            )}
                                            {echeqAction.action === "DEPOSIT" && (
                                                <Hint
                                                    idMessage={`${FORM_ID}.deposit.hint`}
                                                    styleText={{ maxWidth: "100%" }}
                                                    styleImage={{ alignSelf: "center", marginTop: "0.7rem" }}
                                                    classNameHintP="hint-font-size-small"
                                                    alwaysShowMessage
                                                />
                                            )}
                                        </Col>
                                    </Container>
                                    <div className="admin-content-center">
                                        <I18n
                                            id="confirmation.withoutotp.text"
                                            component="p"
                                            componentProps={{ className: "confirmation__text-without-otp" }}
                                        />
                                    </div>
                                </Box>
                                {isDesktop && (
                                    <Col xs={12} md={3} lg={3} className="px-1">
                                        <Button
                                            type="submit"
                                            bsStyle="primary"
                                            label="global.confirm"
                                            onClick={this.executeEcheqAction}
                                            loading={submitting}
                                            image="images/arrowRight.svg"
                                            imageStyle="mr-2"
                                            className="text-capitalize"
                                        />
                                    </Col>
                                )}
                            </Container>
                        )}

                        {!isDesktop && (echeqAction?.action !== "REQUEST-CERTIFICATE" || !enableCAC) && (
                            <Box
                                id="confirmation-without-otp-box-button-mobile"
                                className="p-fixed bottom-0 left-0"
                                css={{
                                    right: 0,
                                    backgroundColor: "#fff",
                                    padding: "15px 20px",
                                    borderTop: "1px solid #e0e0e0",
                                    boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
                                    zIndex: 1000,
                                }}>
                                <Button
                                    type="submit"
                                    bsStyle="primary"
                                    label="global.confirm"
                                    onClick={this.executeEcheqAction}
                                    loading={submitting}
                                    image="images/arrowRight.svg"
                                    imageStyle="mr-2"
                                    className="text-capitalize w-100"
                                    style={{ width: "100%" }}
                                />
                            </Box>
                        )}
                    </div>
                </MainContainer>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    option: selectors.getEcheqOption(state),
    echeqAction: selectors.getEcheqsToDoActions(state),
    accounts: accountsSelectors.getAccounts(state),
    userId: sessionSelectors.getUser(state).userId,
    environmentCuit: selectors.getEnvironmentCuit(state),
    authorizedPersons: selectors.getAuthorizedPersons(state),
    fetching: selectors.getFetching(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: () => ({ otp: "", authorize: false }),
        validationSchema: () =>
            Yup.lazy(({ authorize }) =>
                Yup.object().shape({
                    otp: authorize
                        ? Yup.string().required(i18n.get("form.credential.otp.required"))
                        : Yup.string().notRequired(),
                }),
            ),
        handleSubmit: ({ authorize, otp }, formikBag) => {
            const { dispatch, echeqAction, userId, authorizedPersons } = formikBag.props;
            let cleaned = authorizedPersons;

            if (authorize && (!authorizedPersons || authorizedPersons?.length < 1)) {
                dispatch(
                    notificationActions.showNotification(
                        i18n.get("echeqs.request-certificate.authorized.error"),
                        "error",
                        ["echeqs"],
                    ),
                );
                return;
            }
            if (authorize) {
                cleaned = authorizedPersons?.map((person) => ({
                    ...person,
                    name: person.name.trim(),
                    lastname: person.lastname.trim(),
                    document: person.document.trim(),
                }));
            }

            dispatch(
                actions.executeActionRequestCertificateEcheq(
                    {
                        ...echeqAction,
                        specialAttribute: echeqAction.specialAttribute,
                        specialAttribute2: "",
                        specialAttribute3: "",
                    },
                    userId,
                    authorize,
                    cleaned,
                    otp,
                ),
            );
        },
    }),
)(ConfirmEcheqAction);
